<template>
    <el-popover placement="bottom-start" width="310" trigger="click" :value="visible" @show="visible = true">
        <el-form :model="filterForm" ref="filterForm">
            <el-form-item size="small" prop="dateRange" label="Date Range">
                <el-date-picker
                v-model="filterForm.dateRange"
                format="MM/dd/yyyy"
                value-format="MM/dd/yyyy"
                type="daterange"
                range-separator="-"
                start-placeholder="Start date"
                end-placeholder="End date"
                style="width:100%;">
                </el-date-picker>
            </el-form-item>

            <el-form-item size="small" prop="parser" label="Parser" >
                <el-select v-model="filterForm.parser" placeholder="Select Parser" style="width:100%;">
                    <el-option v-for="(parser, index) in filterParsers" :key="index" :label="parser" :value="parser"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item size="small" prop="userName" label="User" >
                <el-select v-model="filterForm.userName" placeholder="Select User" style="width:100%;">
                    <el-option v-for="(user, index) in filterUsername" :key="index" :label="user" :value="user"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item size="small" prop="status" label="Status" >
                <el-select v-model="filterForm.status" placeholder="Select Status" style="width:100%;">
                    <el-option v-for="(status, index) in filterStatus" :key="index" :label="handleStatusDisplay(status)" :value="status"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item>
                <el-button size="small" type="danger" plain @click="handleClearFilter">Clear</el-button>
                <div style="float: right;">
                    <el-button size="small" type="primary" @click="handleFilter" style="width:8em">Filter</el-button>
                </div>
            </el-form-item>
        </el-form>
        <el-button size="small" type="primary" slot="reference" icon="mdi mdi-filter-menu"> Filter</el-button>
    </el-popover>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import * as type from '../../..//store/types';
import { bus } from '@/main';
export default {
    data(){
        return {
            visible: false,
            filterForm: {
				dateRange: '',
                parser: '',
				userName: '',
                status: ''
			},
        }
    },
    computed: {
        ...mapGetters({
            filterParsers: 'docparser/getFilterParsers',
            filterUsername: 'docparser/getFilterUsername',
            filterStatus: 'docparser/getFilterStatus'
        })
    },
    created(){
        bus.$on('clearUploadHistoryFilter', this.handleClearFilter)
        this.loadFilterOption({ table: 'parser', field: 'parser_name' });
        this.loadFilterOption({ table: 'logs', field: 'curr_user' });
        this.loadFilterOption({ table: 'logs', field: 'status' });
    },
    methods: {
        ...mapActions({
            loadFilterOption: `docparser/${type.DP_GET_FILTER_OPTIONS}`,
            loadImportLogs: `docparser/${type.DP_GET_PARSED_RESULT}`
        }),
        handleStatusDisplay(status){
            return status === 0 ? 'Queued' : status === 1 ? 'Parsing' : status === 2 ? 'Completed' : '';
        },
        handleFilter(){
            let startDate = this.filterForm.dateRange[0];
			let endDate =  this.filterForm.dateRange[1];
            let { userName, parser, status  } = this.filterForm;

            this.loadImportLogs({
                startDate,
                endDate,
                parserName: parser,
                userName,
                status
            });
            this.visible = false;
        },
        handleClearFilter(){
            this.$refs.filterForm.resetFields();
            this.loadImportLogs({});
            this.visible = false;
        }
    }
}
</script>